import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EventService } from '../shared/event.service';
import { EventModel } from '../shared/event.model';
import { FinancialBreakdownComponent } from '../view/financial-breakdown.component';

@Component({
  selector: 'app-financial-breakdown-page',
  standalone: true,
  imports: [CommonModule, FinancialBreakdownComponent],
  template: `
    <div class="container mx-auto px-4 py-6">
      <div class="mb-6">
        <button 
          class="inline-flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-md transition-colors"
          (click)="goBack()">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          Back to Event
        </button>
      </div>

      @if (event) {
        <div class="mb-6">
          <h1 class="text-2xl font-bold text-base-content mb-2">
            Financial Breakdown
          </h1>
          <p class="text-base-content/70">
            {{ event.name }} - Detailed payment allocation analysis
          </p>
        </div>

        <app-financial-breakdown [event]="event"></app-financial-breakdown>
      } @else if (loading) {
        <div class="text-center py-8">
          <div class="loading loading-spinner loading-lg"></div>
          <div class="mt-4">Loading event...</div>
        </div>
      } @else if (error) {
        <div class="alert alert-error">
          <span>{{ error }}</span>
        </div>
      }
    </div>
  `
})
export class FinancialBreakdownPageComponent implements OnInit {
  event: EventModel | null = null;
  loading = false;
  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService
  ) {}

  ngOnInit() {
    const eventId = this.route.snapshot.params['id'];
    if (eventId) {
      this.loadEvent(parseInt(eventId));
    } else {
      this.error = 'Event ID not provided';
    }
  }

  private loadEvent(eventId: number) {
    this.loading = true;
    this.error = null;

    this.eventService.getById(eventId).subscribe({
      next: (response) => {
        this.event = response.data;
        this.loading = false;
      },
      error: (err: any) => {
        this.error = err.message || 'Failed to load event';
        this.loading = false;
        console.error('Error loading event:', err);
      }
    });
  }

  goBack() {
    this.router.navigate(['/events', this.event?.id]);
  }
}